import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-6" }, [
  /*#__PURE__*/_createTextVNode("Zatrudnienie / zajęcie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "error-message" }

import { useField } from 'vee-validate';
import { ref } from 'vue';
import Select from '../../ui/Select.vue';
import NIPField from './NIPField.vue';
import EmployerCompanyName from './EmployerCompanyName.vue';


export default {
  __name: 'WorkerTypeSelect',
  setup(__props) {

const options = ref([
    {
        id: 'Pracownik - osoba cywilna',
        title: 'Pracownik - osoba cywilna',
    },
    {
        id: 'Student / uczeń',
        title: 'Student / uczeń',
    },
    {
        id: 'Pracownik służb mundurowych',
        title: 'Pracownik służb mundurowych',
    },
    {
        id: 'Pracownik w firmie zagranicznej',
        title: 'Pracownik w firmie zagranicznej',
    },
]);

const { value, errorMessage, setValue } = useField('workerType');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(Select, {
        options: options.value,
        selected: _unref(value),
        onOnChange: _unref(setValue)
      }, null, 8, ["options", "selected", "onOnChange"]),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1)
    ]),
    (_unref(value) === 'Pracownik - osoba cywilna')
      ? (_openBlock(), _createBlock(NIPField, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(value) === 'Pracownik w firmie zagranicznej')
      ? (_openBlock(), _createBlock(EmployerCompanyName, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}